// BillingUsageCard.js
import { useFacilityCurrent } from '../../hooks/useFacilityCurrent';

// Cases this period comes from A8 (GET /admin/facility/{id}/usage). Until
// then read metrics_facility_current.cases_this_period, which is absent today.
export default function BillingUsageCard({ facilityId, caseAllowance }) {
    const { data } = useFacilityCurrent(facilityId);
    const used = data?.cases_this_period ?? null;
    return (
        <section className="billing-card">
            <h2 className="billing-card-title">Usage</h2>
            <div className="billing-stat">{used != null ? used : '—'}<span className="billing-stat-sub"> of {caseAllowance ?? '—'} cases this month</span></div>
            <p className="billing-card-detail">Cases over the allowance are billed at the end of the period; they are never blocked.</p>
        </section>
    );
}
